export const getInitial = (firstName, lastName) => {
  let initial = '';
  initial = firstName.split('')[0]+lastName.split('')[0];
  return initial;
}

export const colorPicker = (colorArr) => {
  return colorArr[(Math.round(Math.random() * (colorArr.length - 1)))]
}